import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "days" }
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { class: "items" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "backround-current" }, null, -1)
const _hoisted_6 = { class: "day_number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["icon-arrow-left", [_ctx.innerMonth == 0 && _ctx.innerYear == 1900 ? 'no-active' : '']]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backward && _ctx.backward(...args)))
      }, null, 2),
      _createElementVNode("div", {
        class: "title_date-picker",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeMonth && _ctx.changeMonth(...args)), ["stop"]))
      }, _toDisplayString(_ctx.moment(
            new Date(
              _ctx.year ? _ctx.year : this.innerYear,
              _ctx.month ? _ctx.month : this.innerMonth,
              this.innerDay
            )
          )), 1),
      _createElementVNode("div", {
        class: "icon-arrow-right",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "weekday"
        }, _toDisplayString(_ctx.moment(item, "ddd")), 1))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerDays, (day) => {
        return (_openBlock(), _createElementBlock("div", {
          key: day.date.getTime() + new Date()
        }, [
          _renderSlot(_ctx.$slots, "day", _mergeProps({ ref_for: true }, day), () => [
            _createElementVNode("div", {
              class: _normalizeClass(["day", day.type]),
              onClick: ($event: any) => (_ctx.changeDay(day))
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(day.number), 1)
            ], 10, _hoisted_4)
          ])
        ]))
      }), 128))
    ])
  ]))
}